import { Navigate, Route, Routes } from 'react-router-dom';

import ErrorBoundary from './components/error-boundary';
import { PreviewSessionProvider } from './components/preview-session-context';
import { ProtectedRoute, PublicOnlyRoute } from './components/protected-route';
import { CapabilitiesProvider } from './hooks/use-capabilities';
import CollectionBoardPage from './pages/collection-board-page';
import CollectionsPage from './pages/collections-page';
import ExperiencePage from './pages/experience-page';
import ForgotPasswordPage from './pages/forgot-password-page';
import LoginPage from './pages/login-page';
import NotFoundPage from './pages/not-found-page';
import OtpPage from './pages/otp-page';
import PasswordUpdatedPage from './pages/password-updated-page';
import ProfileSettingsPage from './pages/profile-settings-page';
import ResetPasswordPage from './pages/reset-password-page';
import SignupPage from './pages/signup-page';
import TaskWorkspacePage from './pages/task-workspace-page';
import WelcomePage from './pages/welcome-page';

function App() {
  return (
    <ErrorBoundary>
    {/* Above the router: a preview launched from the experience builder crosses
        /experience/:id to /task/:id, so the run cannot live inside either page. */}
    <PreviewSessionProvider>
    <Routes>
      {/* Public routes — redirect to /app if already logged in */}
      <Route path='/' element={<PublicOnlyRoute><WelcomePage /></PublicOnlyRoute>} />
      <Route path='/signup' element={<PublicOnlyRoute><SignupPage /></PublicOnlyRoute>} />
      <Route path='/login' element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />
      <Route path='/confirm' element={<OtpPage />} />
      <Route path='/forgot-password' element={<PublicOnlyRoute><ForgotPasswordPage /></PublicOnlyRoute>} />
      <Route path='/reset-password' element={<ResetPasswordPage />} />
      <Route path='/password-updated' element={<PasswordUpdatedPage />} />

      {/* Protected routes */}
      <Route
        path='/app/*'
        element={
          <ProtectedRoute>
            {/* Inside the auth gate (it reads /profile) and above every protected page, because a
                capability gates a CONTROL rather than a page — the version pager alone has
                twenty-two mounts across the task editor and the test panel. */}
            <CapabilitiesProvider>
            <Routes>
              {/* Collections browse (landing) + a collection's board */}
              <Route index element={<CollectionsPage />} />
              <Route path='/collection/:id' element={<CollectionBoardPage />} />
              {/* Account and Settings are two distinct pages (each its own menu item) */}
              <Route path='/account' element={<ProfileSettingsPage view='account' />} />
              <Route path='/settings' element={<ProfileSettingsPage view='settings' />} />
              <Route path='/profile' element={<Navigate to='/app/account' replace />} />

              {/* Full-screen routes — own navbar, no shared Layout */}
              <Route path='/experience/:id' element={<ExperiencePage />} />
              <Route path='/task/:id' element={<TaskWorkspacePage />} />
            </Routes>
            </CapabilitiesProvider>
          </ProtectedRoute>
        }
      />

      <Route path='*' element={<NotFoundPage />} />
    </Routes>
    </PreviewSessionProvider>
    </ErrorBoundary>
  );
}

export default App;
